export default {
  getDocumentTemplateField: (state) => state.documentTemplateField,
};
